<ng-template #socialMediaButtons>
    <div class="social-media">
        <a
            href="https://www.facebook.com/astraversicherung"
            aria-label="Asta Versicherung Facebook-Seite"
            target="_blank"
        >
            <img
                alt="Facebook"
                src="assets/icons/icon_facebook.svg"
            />
        </a>
        <a
            href="https://de.linkedin.com/company/astra-versicherung-ag"
            aria-label="Asta Versicherung Linkedin-Seite"
            target="_blank"
        >
            <img
                alt="LinkedIn"
                src="assets/icons/icon_linked_in.svg"
            />
        </a>
        <a
            href="https://www.instagram.com/astraversicherung/"
            aria-label="Asta Versicherung Instagram-Seite"
            target="_blank"
        >
            <img
                alt="Instagram"
                src="assets/icons/icon_instagram.svg"
            />
        </a>
        <a
            href="https://www.tiktok.com/@astraversicherung"
            aria-label="Asta Versicherung Tiktok-Seite"
            target="_blank"
        >
            <img
                alt="TikTok"
                src="assets/icons/icon_tiktok.svg"
            />
        </a>
        <a
            class="footer-button"
            [routerLink]="['vertrag-widerrufen']"
            >Vertrag widerrufen oder kündigen</a
        >
    </div>
</ng-template>

<footer>
    @if (headerMode() === 'default') {
        <nav class="footer-navigation">
            <div class="contact">
                <div class="contact-content">
                    <h3>Kontakt</h3>
                    <p>
                        <b>astra Versicherung AG</b><br />
                        Dudenstr. 46<br />
                        68167 Mannheim
                    </p>
                    <p class="m-16:b">
                        <a
                            class="footer-link"
                            routerLink="./kontakt"
                            >Kontaktformular</a
                        >
                        <br />
                        <a
                            class="footer-link"
                            routerLink="./vertriebspartner"
                            >Vertriebspartner</a
                        >
                    </p>
                </div>
                <ng-container [ngTemplateOutlet]="socialMediaButtons"></ng-container>
            </div>
            <div>
                <h3>Service</h3>
                <p>
                    <a
                        class="footer-link"
                        [routerLink]="['portal', 'schaden-melden']"
                        >Schaden online melden</a
                    >
                    <br />
                    <a
                        class="footer-link"
                        [routerLink]="['portal', 'dashboard']"
                        >Kundenportal</a
                    >
                </p>
            </div>
            <div>
                <h3>Rechtliches</h3>
                <p>
                    <a
                        class="footer-link"
                        routerLink="./impressum"
                        >Impressum</a
                    >
                    <br />
                    <a
                        class="footer-link"
                        routerLink="./datenschutz"
                        >Datenschutz</a
                    >
                    <br />
                    <a
                        class="footer-link"
                        href="/assets/documents/SFCR_astra_Versicherung_20251231.pdf"
                        download="SFCR_astra_Versicherung_20251231.pdf"
                        title="Download: SFCR-Bericht astra Versicherung zum 31.12.2025 (PDF)"
                        >SFCR-Bericht</a
                    >
                </p>
            </div>
            <div>
                <h3>Links</h3>
                <p>
                    <a
                        class="footer-link"
                        href="https://www.astradirect.de/"
                        target="_blank"
                        >astradirect Schließfächer</a
                    >
                    <br />
                    <a
                        class="footer-link"
                        href="https://www.onlinebox.com/"
                        target="_blank"
                        >onlinebox.com</a
                    >
                </p>
            </div>
            <div class="hide lg:block social-media-container">
                <ng-container [ngTemplateOutlet]="socialMediaButtons"></ng-container>
            </div>
        </nav>
    } @else {
        <nav class="minimal-footer-navigation">
            <div>
                <p>
                    <a
                        routerLink="./impressum"
                        class="c:white"
                        >Impressum</a
                    >
                    |
                    <a
                        routerLink="./datenschutz"
                        class="c:white"
                        >Datenschutz</a
                    >
                </p>
            </div>
        </nav>
    }
</footer>
